/**
 * Builds a structured JSON-LD object describing a website with a SearchAction,
 * following the schema.org `WebSite` specification.
 * 
 * This allows search engines (like Google) to display a search box directly in search results.
 */
export function buildSearchAction(args: {
    origin: string;
    siteName: string;
    searchPath: string; // e.g. "/search"
}) {
    const { origin, siteName, searchPath } = args;

    // Ensure the search path starts with a leading slash when concatenated with origin
    const searchUrl = `${origin}${searchPath.startsWith("/") ? "" : "/"}${searchPath}`;

    // Return JSON-LD structure for a WebSite + SearchAction
    return {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "@id": `${origin}/#website`, // Canonical ID for the website entity
        url: `${origin}/`,           // Homepage URL
        name: siteName,              // Human-readable site name
        potentialAction: {
            "@type": "SearchAction",
            // Search endpoint with query template variable
            target: `${searchUrl}?type=all&query={search_term_string}`,
            // Required query parameter definition
            "query-input": "required name=search_term_string",
        },
    };
}
